// KWANKGM03140_住宅ローンしっかり審査事前審査申込入力（受付完了） 申込変更
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import HeadingM from '../../molecules/HeadingM';
import ApplicationInformation from '../../molecules/ApplicationInformation';
import MypageReturn from '../../molecules/MypageReturn';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  ja_name: string;
  is_staff: boolean;
  display_status: boolean;
}

const PreExaminationChangeInputHousingLoanFirmlyFinish: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  ja_name,
  display_status,
  is_staff,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <HeadingM label="事前審査申込変更完了"></HeadingM>
      <div className="p-lead">事前審査申込の変更を完了しました。</div>
      <ApplicationInformation ja_name={ja_name} reception_cd={reception_cd} />
      <MypageReturn is_staff={is_staff} />
    </>
  );
};

export default PreExaminationChangeInputHousingLoanFirmlyFinish;
